import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';

export default function TermsConditions() {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <h1>Terms &amp; Conditions</h1>
        <p className="legal-effective">Effective Date: June 14, 2025</p>
      </section>

      <section className="legal-content">
        <div className="legal-inner">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the website at{' '}
            <a href="https://vectorlabsnc.com">vectorlabsnc.com</a>{' '}
            and any services provided by Vector Labs LLC ("Vector Labs," "we," "us," or "our"),
            including Wallet King, research publications, blog content, and consulting
            services (collectively, the "Services"), you agree to be bound by these Terms &amp; Conditions.
            If you disagree with any part of these terms, you may not access the Services.
          </p>

          <h2>2. Description of Services</h2>
          <p>Vector Labs provides:</p>
          <ul>
            <li><strong>Research Publications:</strong> Open-access AI and engineering research papers.</li>
            <li><strong>Products:</strong> Wallet King, a personal budget tracker at wallet-king.app.</li>
            <li><strong>Blog Content:</strong> Engineering articles, case studies, and technical deep-dives.</li>
            <li><strong>Consulting Services:</strong> AI automation, software engineering, and business process consulting.</li>
            <li><strong>Newsletter &amp; Updates:</strong> Email communications about products, research, and engineering.</li>
          </ul>

          <h2>3. Beta Products</h2>
          <p>
            Products marked as "Beta" are provided as-is for testing and feedback purposes.
            Beta products may:
          </p>
          <ul>
            <li>Contain bugs, errors, or incomplete features</li>
            <li>Be modified, suspended, or discontinued at any time without notice</li>
            <li>Have limited availability or functionality</li>
            <li>Not be suitable for production or critical use cases</li>
          </ul>
          <p>
            By signing up for a beta, you acknowledge these limitations and agree to provide
            constructive feedback when requested.
          </p>

          <h2>4. User Accounts</h2>
          <p>
            Authentication is provided through Google OAuth. By signing in, you:
          </p>
          <ul>
            <li>Warrant that the Google account you use is your own</li>
            <li>Grant us permission to access your name, email, and profile picture</li>
            <li>Are responsible for maintaining the security of your Google account</li>
            <li>Agree that we may send communications to your registered email address</li>
          </ul>

          <h2>5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Services for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to any part of the Services</li>
            <li>Interfere with or disrupt the Services or servers</li>
            <li>Scrape, crawl, or automatically extract content without permission</li>
            <li>Upload malicious code, viruses, or harmful content</li>
            <li>Impersonate any person or entity</li>
            <li>Use the Services to send unsolicited communications (spam)</li>
            <li>Reverse engineer or decompile any part of the Services</li>
          </ul>

          <h2>6. Intellectual Property</h2>
          <p>
            All content, trademarks, logos, software, and materials provided through the Services
            are the property of Vector Labs LLC or its licensors and are protected by intellectual
            property laws. You may not reproduce, distribute, modify, or create derivative works
            without our prior written consent. Research papers published on our platform may have
            specific licensing terms indicated on each publication.
          </p>

          <h2>7. User Content</h2>
          <p>
            By submitting content through our Services (including consultation forms, feedback,
            and communications), you grant Vector Labs a non-exclusive, royalty-free license
            to use such content for the purpose of providing and improving our Services.
          </p>

          <h2>8. Email Communications</h2>
          <p>
            By subscribing to our newsletter or signing up for product betas, you consent to
            receive email communications from us. These may include:
          </p>
          <ul>
            <li>Product updates and beta invitations</li>
            <li>Engineering blog digests</li>
            <li>Research publication announcements</li>
            <li>Service announcements and policy changes</li>
          </ul>
          <p>
            You may unsubscribe at any time by replying "unsubscribe" to any email or contacting us directly.
          </p>

          <h2>9. Consulting Services</h2>
          <p>
            Consulting engagements are subject to separate agreements. Submitting a consultation
            request does not create a binding contract. Specific terms, deliverables, timelines,
            and fees will be outlined in a separate Statement of Work (SOW) or engagement letter.
          </p>

          <h2>10. Disclaimer of Warranties</h2>
          <p>
            THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND,
            EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
          </p>
          <p>
            We do not warrant that the Services will be uninterrupted, error-free, secure, or
            free of viruses or other harmful components. We do not guarantee the accuracy,
            completeness, or usefulness of any information provided through the Services.
          </p>

          <h2>11. Limitation of Liability</h2>
          <p>
            IN NO EVENT SHALL VECTOR LABS LLC, ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS,
            SUPPLIERS, OR AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL
            OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL,
            OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
          </p>
          <ul>
            <li>Your access to or use of (or inability to access or use) the Services</li>
            <li>Any conduct or content of any third party on the Services</li>
            <li>Any content obtained from the Services</li>
            <li>Unauthorized access, use, or alteration of your transmissions or content</li>
          </ul>

          <h2>12. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless Vector Labs LLC and its officers,
            directors, employees, and agents from any claims, damages, obligations, losses,
            liabilities, costs, or debt arising from your use of the Services or violation of
            these Terms.
          </p>

          <h2>13. Termination</h2>
          <p>
            We may terminate or suspend your access to the Services immediately, without prior
            notice or liability, for any reason, including breach of these Terms. Upon termination,
            your right to use the Services will immediately cease. All provisions that by their
            nature should survive termination shall survive.
          </p>

          <h2>14. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the
            State of North Carolina, United States, without regard to its conflict of law provisions.
          </p>

          <h2>15. Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time. Material changes
            will be communicated by posting the updated Terms on this page and updating the
            effective date. Your continued use of the Services after changes constitutes acceptance
            of the new Terms.
          </p>

          <h2>16. Severability</h2>
          <p>
            If any provision of these Terms is found to be unenforceable or invalid, that provision
            will be limited or eliminated to the minimum extent necessary, and the remaining
            provisions will remain in full force and effect.
          </p>

          <h2>17. Contact Us</h2>
          <p>If you have any questions about these Terms, please contact us at:</p>
          <ul>
            <li>Email: <a href="mailto:alvarezjd404@gmail.com">alvarezjd404@gmail.com</a></li>
            <li>Website: <a href="https://vectorlabsnc.com/consulting">vectorlabsnc.com/consulting</a></li>
          </ul>

          <div className="legal-nav">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/">Back to Home</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
